import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Card, CardBody, CardHeader } from 'reactstrap';
import ReactTable from '../../../components/ReactTable/ReactTable';
import ExamDocApi from '../../../api/ExamDocApi';
import ApiCaller from '../../../lib/ApiCaller';
import { AppState } from '../../../store/store';
import MYDocumentStatusLog from '../../../lib/common/models/myDocumentStatusLog';
import MYDocumentStatusLogCollection from '../../../lib/common/models/myDocumentStatusLogCollection';
import { MYDocumentStatus } from '../../../lib/common/models/myDocument';
import { DEFAULT_TIMEZONE_FORMAT, formatDateTime, sortDateTable } from '../../../shared/utils/dateTime';

type DocumentTrailTableProps = {
  documentId?: string;
  navigationExamId?: string;
  hideTitle?: boolean;
};

const DocumentTrailTable: React.FC<DocumentTrailTableProps> = ({ documentId, navigationExamId, hideTitle }) => {
  const loggedUser = useSelector((state: AppState) => state.session.userInfo);
  const [statuses, setStatuses] = useState<MYDocumentStatusLogCollection>(
    new MYDocumentStatusLogCollection([]),
  );

  useEffect(() => {
    const docApi = new ExamDocApi(new ApiCaller());
    if (documentId) {
      docApi
        .loadAllStatusLogs(documentId, loggedUser.token)
        .then((s: MYDocumentStatusLogCollection) => setStatuses(s));
    } else if (navigationExamId) {
      docApi
        .loadAllStatusLogsByNavigationExamId(navigationExamId, loggedUser.token)
        .then((s: MYDocumentStatusLogCollection) => setStatuses(s));
    }
  }, [documentId, navigationExamId, loggedUser.token]);

  const columns = [
    {
      Header: 'TIMESTAMP',
      accessor: (d: MYDocumentStatusLog) =>
        formatDateTime(d.timestamp, DEFAULT_TIMEZONE_FORMAT),
      sortable: true,
      sortType: (a: MYDocumentStatusLog, b: MYDocumentStatusLog) =>
        sortDateTable(a, b, 'timestamp'),
    },
    {
      Header: 'STATUS',
      accessor: (d: MYDocumentStatusLog) =>
        d.status ? MYDocumentStatus[d.status as keyof typeof MYDocumentStatus] : '',
      sortable: true,
    },
    {
      Header: 'COMMENT',
      accessor: (d: MYDocumentStatusLog) => (d.comment ? d.comment : ''),
      sortable: true,
    },
    {
      Header: 'EDITOR',
      accessor: (d: MYDocumentStatusLog) =>
        (d as any).createdBy && typeof (d as any).createdBy === 'object'
          ? (d as any).createdBy.name
          : '-',
      sortable: true,
    },
  ];

  return (
    <div className="content">
      <Card>
        {!hideTitle && (
          <CardHeader>
            <h4 className="card-title">Document Trail</h4>
          </CardHeader>
        )}
        <CardBody>
          <ReactTable data={statuses.data} columns={columns} />
        </CardBody>
      </Card>
    </div>
  );
};

export default DocumentTrailTable;


